import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/footer';
import AppRoutes from './routes/AppRoutes';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollTop from './components/ScrollTop';

// ✅ Component to track page views
const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if Meta Pixel is loaded
    if (window.fbq) {
      window.fbq('track', 'PageView');
      window.fbq('track', 'ViewContent', {
        page_path: location.pathname
      });
    }
  }, [location]);

  return null;
};

const AppShell = () => {
  const location = useLocation();
  const path = location.pathname || "";
  const isApplyNew = path === "/apply-new" || path.startsWith("/apply-new/");
  const isApplyLoan = path === "/apply-loan" || path.startsWith("/apply-loan/");
  const isApplyNow = path === "/apply-now" || path.startsWith("/apply-now/");
  const isLanding = path === "/landing" || path.startsWith("/landing/");
  const isAggregatorThankYou =
    path === "/thank-you-aggregator" ||
    path === "/aggregator-thank-you";
  const hideChrome =
    isApplyNew || isApplyLoan || isApplyNow || isLanding || isAggregatorThankYou;

  return (
    <>
      <MetaPixelTracker />
      <ScrollTop />
      {!hideChrome && <ScrollToTopButton />}
      {!hideChrome && <Navbar />}
      <AppRoutes />
      {!hideChrome && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppShell />
    </Router>
  );
};

export default App;
